<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>

      <!-- <h1 >File Upload</h1>

         <v-flex md12 >
 
                <input
                  type="file"
                  ref="excelFile"
                  @change="importExcel($event)"
                >
                  </v-flex> -->


      <v-flex lg6 md6 sm6>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="lectureOption"
              :series="lectureSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>
      
      <v-flex lg6 md6 sm6>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="subjectOption"
              :series="subjectSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>
      
      <v-flex lg12 md12 sm12>
        <v-card>
          <div id="chart">
            <apexchart
              type="bar"
              :options="topVideoChartOptions"
              :series="topVideoSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-card>
      <div id="chart">
        <!-- <apexchart width="500" type="line" :options="options" :series="series"></apexchart> -->
        <!-- <apexchart width="380" type="line" :options="line_options" :series="line_series"></apexchart> -->
      </div>
      <!-- <p v-for="dev in devices" :key="dev.android_id">{{ dev.device_model }}</p> -->
      <!-- <br><br><br> -->
      <!-- <p v-for="(user, index) in users" :key="index">{{ user[Object.keys(user)].device_name }}</p> -->
    </v-card>
  </v-container>
</template>

<script>
import xlsx from "xlsx";

import VueApexCharts from "vue-apexcharts";
import firebase from "firebase/app";
import bus from "../bus";
import { deviceRef, userSessionRef, streamingVideosRef } from "../firebase";
import { setTimeout } from 'timers';
import { mapGetters, mapActions, mapState } from "vuex";

import Pusher from 'pusher-js'
const socket = new Pusher('8b7b2278694ce750e2e5', {
  cluster: 'mt1',
  encrypted: true
})
const channel = socket.subscribe('newLecture')
const channelViewLecture = socket.subscribe('viewLecture')

// Vue.use(require('vue-pusher'), {
//   api_key: '8b7b2278694ce750e2e5',
//   options: {
//     cluster: 'mt1',
//     forceTLS: true,
//     encrypted: true
//   }
// })


export default {


  components: {
    apexchart: VueApexCharts
  },
  firebase: {
    devices: deviceRef
  },
  
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('dashboard', ['lectureCountList', 'courseList', 'lectureOption', 'lectureSeries', 'subjectOption', 'subjectSeries', 'liveStreamingNumber' , 'topVideoSeries', 'topVideoChartOptions']),
  },
  
  data() {
    return {
   
      items: [],
      devices: [],
      valueLive: [],
      users: [],
      streamingVideos: [],
      options: {
        chart: {
          id: "bar-chart"
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
          categories: ['Users', 'Devices', 'Live Streaming']
        }
      },
      series: [
        {
          name: "Device graph",
          data: []
        }
      ],

      pie_series: [45, 55, 70],
      chartOptions: {
        labels: ["Female", "Male", "Not mentioned", ],
        theme: {
          monochrome: {
            enabled: true
          }
        },
        title: {
          text: "Number of leads"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      }
    };
  },
  watch: {
    liveStreamingNumber: function (val) {
      // this.series[0].data[2] = val
      let seriesData = this.series[0].data
      seriesData[2] = val
      
        this.$refs.deviceGraph.updateSeries([
          {
            data: seriesData
          }
        ]);
    }
  },
  created() {

  // let cookie = null
  // cookie = this.getCookie('Info')
  // this.adminUser = JSON.parse(cookie)


  let self = this
  channel.bind('lecture-created', function (data) {
      console.log(data);
      self.getLecturesNumberForLMS()
      // this.valueLive = 3
    });
    
  channelViewLecture.bind('lecture-viewed', function (data) {
      self.getTodayVideos()
    });
  this.getLecturesNumberForLMS()
  this.getSubjectNumberByCourse()
  this.getFirebaseData()
  this.getFirebaseDataFromStore()
  this.getTodayVideos()
  },
  methods: {
    ...mapActions("dashboard", ["getLecturesNumberForLMS", "getFirebaseDataFromStore", 'setLiveStreamingNumber', 'getSubjectNumberByCourse', 'getTodayVideos', 'uploadInstituteAssistance']),

    getFirebaseData () {
      let self = this
       deviceRef.on("child_added", snapshot => {
        let val = snapshot.val();
        this.devices.push({ ...val });
      });
      userSessionRef.on("child_added", snapshot => {
        let val = snapshot.val();
        this.users.push({ ...val });
      });

      streamingVideosRef.on("child_added", snapshot => {
        let val = snapshot.val();
        let videoInfo = val[Object.keys(val)[0]]
        if (videoInfo.playing) 
          self.streamingVideos.push(videoInfo);
      });
      streamingVideosRef.on("child_removed", snapshot => {
        let val = snapshot.val();
        let videoInfo = val[Object.keys(val)[0]]
        self.streamingVideos.splice(self.streamingVideos.indexOf(videoInfo), 1);
      });
      this.series[0].data.push(this.users.length, this.devices.length, self.streamingVideos.length);

    },
    importExcel(e) {   
      const files = e.target.files;     
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls or xlsx format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          this.items = [];
          // Edit data
          for (var i = 0; i < ws.length; i++) {
     
            this.items.push({
              institute_name: ws[i].institute_name,
              medium: ws[i].medium,
              level: ws[i].level,
              phone_number: ws[i].phone_number,
              email: ws[i].email,
              admission_procedure_url: ws[i].admission_procedure_url,
              admission_procedure_text: ws[i].admission_procedure_text,
              admission_requirments: ws[i].admission_requirments,
              contact_address: ws[i].contact_address,
              institute_url: ws[i].institute_url,
              admission_url: ws[i].admission_url
            });


            //excelRecipientList
         //   excellist.push(ws[i]);
          }

          if(this.items.length > 0){
            this.uploadInstituteAssistance({items: this.items});
          }
        //  console.log("Read results", excellist); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
         // const a = workbook.Sheets[workbook.SheetNames[0]];
       //   const headers = this.getHeader(a);
        //  console.log("headers", headers);
          // Get header2-2
        } catch (e) {
          return alert(e);
        }
      };
      fileReader.readAsBinaryString(files[0]);
      // var input = document.getElementById("upload");
      // input.value = "";
    }
  }
};
</script>
